import { httpPost } from "../http"

interface TransportContractRequest {
  engagement_id: number
}

export async function getTransportContractHtml(data: TransportContractRequest) {
  const resp = await httpPost(
    "be-transport-contract/customer/get_transport_contract",
    data
  )

  return resp.data
}
